import React, { useEffect, useState } from 'react';

const LogoDiv = ({ children, className }) => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    const checkScreenSize = () => {
        setIsSmallScreen(window.innerWidth < 1445); // Adjust the breakpoint as needed
    };

    useEffect(() => {
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, [isSmallScreen]);

    return (
        <div className={isSmallScreen ? '' : className}>
            {children}
        </div>
    );
};

export default LogoDiv;
